import * as actionTypes from '../actions/actionTypes';

export default function currentProductAccountReducer(state = [], action) {
  switch(action.type){
    case actionTypes.SET_ADDRESSES: {
      return action.addresses;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/addressesReducer.js